<div class="tree-container">
  <mat-tree
    class="scroll-container"
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    cdkScrollable
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    <mat-tree-node
      (click)="openNode($event, node)"
      class="drag-container"
      [ngClass]="{ 'selected-node': node.isActive === true }"
      *matTreeNodeDef="let node"
      matTreeNodePadding
      matTreeNodePaddingIndent="5"
      (cdkDragStarted)="onDragStarted($event, node)"
      cdkDrag
    >
      <button class="page-menu-icon">
        <img
          style="height: 12px; width: 12px"
          src="assets/icons/leftmenu-node-icon.png"
        />
      </button>
      <div
        [matTooltip]="node.item"
        matTooltipPosition="above"
        class="tree-node-text" [ngClass]="{ 'active-node': node.isActive === true }"
      >
        {{ node.item }}
      </div>
      <div class="tree-node-page-type" [style.background]="node.pageTypeColor">
        <button
          *ngIf="node.pageType"
        >
          {{ node.pageType }}
        </button>
        <button
          class="page-menu-button"
          mat-icon-button
          [matMenuTriggerFor]="pageMenu"
          (click)="clickedNode = node; $event.stopPropagation()"
          aria-label="Page options"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <!-- Drag handle -->
      <button
        *ngIf="permissions?.includes('page.update')"
        class="drag-handle"
        mat-icon-button
        cdkDragHandle
      >
        <mat-icon>drag_indicator</mat-icon>
      </button>
    </mat-tree-node>
    <mat-tree-node
      class="drag-container"
      [ngClass]="{ 'selected-node': node.isActive === true }"
      *matTreeNodeDef="let node; when: isbook"
      matTreeNodePadding
      matTreeNodePaddingIndent="5"
      matTreeNodeToggle
      [cdkTreeNodeTypeaheadLabel]="node.item"
      [ngClass]="{ 'active-node': node.isActive === true }"
      (cdkDragStarted)="onDragStarted($event, node)"
      cdkDrag
    >
      <button
        mat-icon-button
        [attr.aria-label]="'Toggle ' + node.item"
        matTreeNodeToggle
        class="expand-node-button"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      <div
        [matTooltip]="node.item"
        matTooltipPosition="above"
        (click)="openNode($event, node)"
        class="tree-node-text" [ngClass]="{ 'active-node': node.isActive === true }"
      >
        {{ node.item }}
      </div>
      <button
        *ngIf="permissions?.includes('book.update')"
        (click)="setActiveNode($event, node)"
        class="drag-handle"
        mat-icon-button
        cdkDragHandle
      >
        <mat-icon>drag_indicator</mat-icon>
      </button>
    </mat-tree-node>
    <mat-tree-node
      class="drag-container node-separator"
      [ngClass]="{ 'selected-node': node.isActive === true }"
      *matTreeNodeDef="let node; when: ischapter"
      matTreeNodePadding
      matTreeNodePaddingIndent="10"
      matTreeNodeToggle
      [cdkTreeNodeTypeaheadLabel]="node.item"
      [ngClass]="{ 'active-node': node.isActive === true }"
      (cdkDragStarted)="onDragStarted($event, node)"
      cdkDrag
    >
      <button
        mat-icon-button
        [attr.aria-label]="'Toggle ' + node.item"
        matTreeNodeToggle
        class="expand-node-button"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      <div
        [matTooltip]="node.item"
        matTooltipPosition="above"
        (click)="openNode($event, node)"
        class="tree-node-text" [ngClass]="{ 'active-node': node.isActive === true }"
      >
        {{ node.item }}
      </div>
      <button
        *ngIf="node.type > 0 && permissions?.includes('page.create')"
        [cdkMenuTriggerFor]="story_menu"
        class="tree-node-add-btn"
        (click)="setActiveNode($event, node)"
      >
        ADD PAGE
      </button>
      <button
        *ngIf="permissions?.includes('book.update')"
        (click)="setActiveNode($event, node)"
        class="drag-handle"
        mat-icon-button
        cdkDragHandle
      >
        <mat-icon>drag_indicator</mat-icon>
      </button>
    </mat-tree-node>
    <ng-template #story_menu>
      <div class="asher-tree-menu" cdkMenu>
        <button
          *ngFor="let type of pageTypes"
          class="asher-tree-menu-item"
          cdkMenuItem
          (click)="addPage(type)"
        >
          {{ type }}
        </button>
      </div>
    </ng-template>
  </mat-tree>

  <mat-menu #pageMenu="matMenu">
    <button mat-menu-item class="tree-page-menu-option" (click)="changePageType(clickedNode)">
      <mat-icon>swap_horiz</mat-icon>
      <span>Change Page Type</span>
    </button>
    <button mat-menu-item class="tree-page-menu-option" (click)="deletePage(clickedNode)">
      <mat-icon class="page-delete-icon">delete</mat-icon>
      <span>Delete Page</span>
    </button>
  </mat-menu>
</div>
